import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Toaster } from '@/components/ui/sonner';
import { installBridgeMock } from './lib/bridgeMock';
import { installThemeSync } from './lib/themeSync';
import './index.css';

// 浏览器里单独看页面：`?mock=1`（dev 默认也装）。生产构建是空操作。
installBridgeMock();

// 主题：默认跟随系统，App 内由 app.info.theme 覆盖。
installThemeSync();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <Toaster position="top-center" />
  </StrictMode>,
);
